import React, { useEffect, useState } from "react";

declare global {
  interface Window {
    Cookiebot?: {
      renew: () => void;
      consent?: {
        marketing: boolean;
      };
    };
  }
}

interface YouTubePlayerProps {
  videoId: string;
}

const YouTubePlayer: React.FC<YouTubePlayerProps> = ({ videoId }) => {
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const hasConsent = isMarketingConsentGiven();
      setConsentGiven(hasConsent);
    };

    checkConsent();

    const handleConsentUpdate = () => {
      checkConsent();
    };

    window.addEventListener("CookiebotOnAccept", handleConsentUpdate);
    window.addEventListener("CookiebotOnDecline", handleConsentUpdate);

    return () => {
      window.removeEventListener("CookiebotOnAccept", handleConsentUpdate);
      window.removeEventListener("CookiebotOnDecline", handleConsentUpdate);
    };
  }, []);

  const handleConsentClick = () => {
    if (window.Cookiebot) {
      window.Cookiebot.renew();
    }
  };

  return (
    <div className="video-responsive relative pt-[56.25%] overflow-hidden rounded-xl">
      {consentGiven ? (
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src={`https://www.youtube.com/embed/${videoId}?fs=1&iv_load_policy=3`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded YouTube Video"
        />
      ) : (
        <div className="cookieconsent-optout-marketing" onClick={handleConsentClick}>
          <p>You need to</p>
          <button type="button">accept marketing-cookies</button>
          <p>to watch this video.</p>
        </div>
      )}
    </div>
  );
};

export default YouTubePlayer;

const isMarketingConsentGiven = () => {
  return window.CookieConsent?.consent?.marketing ?? false;
};
